import { render, staticRenderFns } from "./DocumentDraftingSignApproval.vue?vue&type=template&id=01d56672&scoped=true"
import script from "./DocumentDraftingSignApproval.vue?vue&type=script&lang=js"
export * from "./DocumentDraftingSignApproval.vue?vue&type=script&lang=js"
import style0 from "./DocumentDraftingSignApproval.vue?vue&type=style&index=0&id=01d56672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d56672",
  null
  
)

export default component.exports